import React from 'react'
import FilePreview from '../../filePreview/FilePreview'
import { APISettings } from '../../../../config/ApiSettings'
import { Icon } from '@progress/kendo-react-common'
import { useFileTabController } from './FileTabController'
import CustomButton from '../../../stateless/customButton/CustomButton'

interface IFileTabProps {
  filingId: number,
}

const FileTab = (props: IFileTabProps) => {
  const {
    filingId
  } = props

  const {
    filingSupportingDocs,
    filingHearingDocs,
    filingAffidavitDocs,
    filingSummaryDocs,
    filingFiscalDocs,
    filingExplanatoryDocs,
    filingGPRODocs,
    filingCoverLetterDocs,
    filingCertificateOfAdoptionDocs,
    downloadPdf
  } = useFileTabController(filingId);


  const render = (files: any, label: string) => {
    if (!!files) {
      return (
        <>
          <div className='header-bar'>{label}</div>
          {files.map((file: any, index: number) => {
            return (
              <div key={file.blobName} className="filing-documents">
                <div>
                  <div style={{display:'flex'}}>
                    <p>{file.originalName}</p>
                    <CustomButton onClick={() => {downloadPdf('filing-documents', file.blobName)}} themeColor='success' size='small' icon='download' />
                  </div>
                  <FilePreview containerName='filing-documents' blobName={file.blobName} type={'image'} width={"300px"} height={"400px"} />
                </div>
              </div>
            )
          })}
          {files.length < 1 && (
            <div style={{marginBottom:"10px"}}>
              No corresponding records found.
            </div>
          )}
        </>
      );
    }
    return (<></>);
  }

  return (
    <div>
      {render(filingAffidavitDocs, 'Affidavit of Publication')}
      {render(filingCertificateOfAdoptionDocs, 'Certificate of Adoption')}
      {render(filingCoverLetterDocs, 'Cover Letters and Statements')}
      {render(filingExplanatoryDocs, 'Explanatory Statement')}
      {render(filingFiscalDocs, 'Fiscal Impact Statement')}
      {render(filingGPRODocs, 'Gov Checklist')}
      {render(filingHearingDocs, 'Hearing Notice')}
      {render(filingSummaryDocs, 'Hearing Summary')}
      {render(filingSupportingDocs, 'Additional Files')}
    </div>
  )
}

export default FileTab